export const measurementCategories = [
  { value: 'blinds-shades', display: 'Blinds/Shades' },
  { value: 'roller-shades', display: 'Roller Shades' },
  { value: 'verticals', display: 'Vertical Blinds' },
  { value: 'perfect-arch', display: 'Perfect Arches' },
];
export const mountTypes = [
  { value: 'inside', display: 'Inside' },
  { value: 'outside', display: 'Outside' },
];
